export class ProductsClass {
    constructor({
                    //attributes
                    id = null,
                    company_id = null,
                    name = '',
                    group_id = null,
                    created_at = new Date(),
                    updated_at = new Date(),
                    deleted_at = null,

                    //relations
                    variables = [],
                    group = null
                } = {}) {

        //fill attributes

        this.id = id;
        this.company_id = company_id;
        this.name = name;
        this.group_id = group_id;
        this.created_at = created_at;
        this.updated_at = updated_at;
        this.deleted_at = deleted_at

        //fill relations
        this.variables = variables;
        this.group = group;
    }

}

export function createProductsClass(data={}) {
    return Object.freeze(new ProductsClass(data));
}